import React, { Fragment } from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import { Loading, PasswordPolicyTooltip } from 'Components';
import ColorLink from './ColorLink';

const PasswordChangeForm = ({
  t,
  username,
  currentPassword,
  newPassword,
  confirmPassword,
  showPassword,
  usernameError,
  currentPasswordError,
  newPasswordError,
  confirmPasswordError,
  newPasswordSameAsCurrentError,
  newPasswordBackendError,
  passwordPolicy,
  isLoadingPasswordPolicy,
  isLoading,
  buttonColor,
  usernameReadOnly = false,
  currentPasswordReadOnly = false,
  onUsernameChange,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onToggleShowPassword,
  onSubmit,
  loginLinkTo,
  showLoginLink = true,
}) => (
  <Fragment>
    <FormControl fullWidth className='mb-12'>
      <TextField
        label={t('Email or phone number')}
        margin='dense'
        variant='outlined'
        value={username}
        error={!usernameReadOnly && usernameError}
        helperText={!usernameReadOnly && usernameError ? t('Email or phone number') : ''}
        onChange={(event) => onUsernameChange(event.target.value)}
        disabled={usernameReadOnly}
        inputProps={usernameReadOnly ? { readOnly: true } : undefined}
      />
    </FormControl>

    <FormControl fullWidth className='mb-12'>
      <TextField
        label={t('Current password')}
        margin='dense'
        variant='outlined'
        type={showPassword ? 'text' : 'password'}
        value={currentPassword}
        error={!currentPasswordReadOnly && currentPasswordError}
        helperText={!currentPasswordReadOnly && currentPasswordError ? t('Enter your password') : ''}
        onChange={(event) => onCurrentPasswordChange(event.target.value)}
        disabled={currentPasswordReadOnly}
        inputProps={currentPasswordReadOnly ? { readOnly: true } : undefined}
      />
    </FormControl>

    <FormControl fullWidth className='mb-12'>
      <TextField
        label={t('New password')}
        margin='dense'
        variant='outlined'
        type={showPassword ? 'text' : 'password'}
        value={newPassword}
        error={newPasswordError}
        helperText={
          newPasswordError
            ? (
              newPasswordSameAsCurrentError
                ? t('New password must be different from current password')
                : newPasswordBackendError || t('A minimum of {{minLength}} characters in length', { minLength: passwordPolicy.minLength })
            )
            : ''
        }
        onChange={(event) => onNewPasswordChange(event.target.value)}
        InputProps={{
          endAdornment: isLoadingPasswordPolicy ? (
            <InputAdornment position='end' className='color-gray'>
              <Loading visible />
            </InputAdornment>
          ) : (
            <PasswordPolicyTooltip passwordPolicy={passwordPolicy} />
          ),
        }}
      />
    </FormControl>

    <FormControl fullWidth className='mb-12'>
      <TextField
        label={t('Confirm new password')}
        margin='dense'
        variant='outlined'
        type={showPassword ? 'text' : 'password'}
        value={confirmPassword}
        error={confirmPasswordError}
        helperText={confirmPasswordError ? t('Passwords do not match') : ''}
        onChange={(event) => onConfirmPasswordChange(event.target.value)}
      />
    </FormControl>

    <FormGroup className='mb-12'>
      <FormControlLabel
        control={<Checkbox checked={showPassword} onChange={onToggleShowPassword} color='primary' />}
        label={<span className='color-gray'>{t('Show password')}</span>}
      />
    </FormGroup>

    <FormControl fullWidth className='mb-12'>
      <Button color='primary' style={{ color: buttonColor }} variant='contained' disabled={isLoading} onClick={onSubmit}>
        <Loading visible={isLoading} /> {t('Update password')}
      </Button>
    </FormControl>

    {showLoginLink && (
      <FormControl fullWidth className='mb-12'>
        <Typography variant='body1' className='justify-content-end'>
          <ColorLink to={loginLinkTo}>
            {t('Login')}
          </ColorLink>
        </Typography>
      </FormControl>
    )}
  </Fragment>
);

export default PasswordChangeForm;
